/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createProductLibProduct = /* GraphQL */ `mutation CreateProductLibProduct(
  $input: CreateProductLibProductInput!
  $condition: ModelProductLibProductConditionInput
) {
  createProductLibProduct(input: $input, condition: $condition) {
    id
    brand
    brandType
    materialCode
    materialName
    barcode
    productHierachy
    name
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    description
    descriptionEN
    descriptionTH
    images
    functions
    tags
    packageCaseUpdatedAt
    lastUpdatedDate
    files {
      items {
        id
        brand
        brandType
        name
        materialCode
        materialName
        barcode
        productHierachy
        mediaType
        mediaTypeSub
        titleEN
        titleTH
        category
        subcategory
        collection
        color
        classifier
        packaging
        status
        length
        width
        height
        weight
        weightUnit
        baseSize
        path
        description
        functions
        tags
        lastUpdatedDate
        createdAt
        updatedAt
        productLibProductFilesId
        __typename
      }
      nextToken
      __typename
    }
    eaPerCase
    eaPerPack
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibProductMutationVariables,
  APITypes.CreateProductLibProductMutation
>;
export const updateProductLibProduct = /* GraphQL */ `mutation UpdateProductLibProduct(
  $input: UpdateProductLibProductInput!
  $condition: ModelProductLibProductConditionInput
) {
  updateProductLibProduct(input: $input, condition: $condition) {
    id
    brand
    brandType
    materialCode
    materialName
    barcode
    productHierachy
    name
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    description
    descriptionEN
    descriptionTH
    images
    functions
    tags
    packageCaseUpdatedAt
    lastUpdatedDate
    files {
      items {
        id
        brand
        brandType
        name
        materialCode
        materialName
        barcode
        productHierachy
        mediaType
        mediaTypeSub
        titleEN
        titleTH
        category
        subcategory
        collection
        color
        classifier
        packaging
        status
        length
        width
        height
        weight
        weightUnit
        baseSize
        path
        description
        functions
        tags
        lastUpdatedDate
        createdAt
        updatedAt
        productLibProductFilesId
        __typename
      }
      nextToken
      __typename
    }
    eaPerCase
    eaPerPack
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibProductMutationVariables,
  APITypes.UpdateProductLibProductMutation
>;
export const deleteProductLibProduct = /* GraphQL */ `mutation DeleteProductLibProduct(
  $input: DeleteProductLibProductInput!
  $condition: ModelProductLibProductConditionInput
) {
  deleteProductLibProduct(input: $input, condition: $condition) {
    id
    brand
    brandType
    materialCode
    materialName
    barcode
    productHierachy
    name
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    description
    descriptionEN
    descriptionTH
    images
    functions
    tags
    packageCaseUpdatedAt
    lastUpdatedDate
    files {
      items {
        id
        brand
        brandType
        name
        materialCode
        materialName
        barcode
        productHierachy
        mediaType
        mediaTypeSub
        titleEN
        titleTH
        category
        subcategory
        collection
        color
        classifier
        packaging
        status
        length
        width
        height
        weight
        weightUnit
        baseSize
        path
        description
        functions
        tags
        lastUpdatedDate
        createdAt
        updatedAt
        productLibProductFilesId
        __typename
      }
      nextToken
      __typename
    }
    eaPerCase
    eaPerPack
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibProductMutationVariables,
  APITypes.DeleteProductLibProductMutation
>;
export const createProductLibFile = /* GraphQL */ `mutation CreateProductLibFile(
  $input: CreateProductLibFileInput!
  $condition: ModelProductLibFileConditionInput
) {
  createProductLibFile(input: $input, condition: $condition) {
    id
    brand
    brandType
    name
    materialCode
    materialName
    barcode
    productHierachy
    mediaType
    mediaTypeSub
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    path
    description
    functions
    tags
    lastUpdatedDate
    createdAt
    updatedAt
    productLibProductFilesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibFileMutationVariables,
  APITypes.CreateProductLibFileMutation
>;
export const updateProductLibFile = /* GraphQL */ `mutation UpdateProductLibFile(
  $input: UpdateProductLibFileInput!
  $condition: ModelProductLibFileConditionInput
) {
  updateProductLibFile(input: $input, condition: $condition) {
    id
    brand
    brandType
    name
    materialCode
    materialName
    barcode
    productHierachy
    mediaType
    mediaTypeSub
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    path
    description
    functions
    tags
    lastUpdatedDate
    createdAt
    updatedAt
    productLibProductFilesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibFileMutationVariables,
  APITypes.UpdateProductLibFileMutation
>;
export const deleteProductLibFile = /* GraphQL */ `mutation DeleteProductLibFile(
  $input: DeleteProductLibFileInput!
  $condition: ModelProductLibFileConditionInput
) {
  deleteProductLibFile(input: $input, condition: $condition) {
    id
    brand
    brandType
    name
    materialCode
    materialName
    barcode
    productHierachy
    mediaType
    mediaTypeSub
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    path
    description
    functions
    tags
    lastUpdatedDate
    createdAt
    updatedAt
    productLibProductFilesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibFileMutationVariables,
  APITypes.DeleteProductLibFileMutation
>;
export const createProductLibProcessJob = /* GraphQL */ `mutation CreateProductLibProcessJob(
  $input: CreateProductLibProcessJobInput!
  $condition: ModelProductLibProcessJobConditionInput
) {
  createProductLibProcessJob(input: $input, condition: $condition) {
    id
    jobType
    status
    isActive
    createdDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibProcessJobMutationVariables,
  APITypes.CreateProductLibProcessJobMutation
>;
export const updateProductLibProcessJob = /* GraphQL */ `mutation UpdateProductLibProcessJob(
  $input: UpdateProductLibProcessJobInput!
  $condition: ModelProductLibProcessJobConditionInput
) {
  updateProductLibProcessJob(input: $input, condition: $condition) {
    id
    jobType
    status
    isActive
    createdDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibProcessJobMutationVariables,
  APITypes.UpdateProductLibProcessJobMutation
>;
export const deleteProductLibProcessJob = /* GraphQL */ `mutation DeleteProductLibProcessJob(
  $input: DeleteProductLibProcessJobInput!
  $condition: ModelProductLibProcessJobConditionInput
) {
  deleteProductLibProcessJob(input: $input, condition: $condition) {
    id
    jobType
    status
    isActive
    createdDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibProcessJobMutationVariables,
  APITypes.DeleteProductLibProcessJobMutation
>;
export const createProductLibAppIAM = /* GraphQL */ `mutation CreateProductLibAppIAM(
  $input: CreateProductLibAppIAMInput!
  $condition: ModelProductLibAppIAMConditionInput
) {
  createProductLibAppIAM(input: $input, condition: $condition) {
    id
    username
    name
    email
    role
    departmentMain
    departmentSub
    editorBrandTypes
    approverBrandTypes
    skipNotificationBrandTypes
    notifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibAppIAMMutationVariables,
  APITypes.CreateProductLibAppIAMMutation
>;
export const updateProductLibAppIAM = /* GraphQL */ `mutation UpdateProductLibAppIAM(
  $input: UpdateProductLibAppIAMInput!
  $condition: ModelProductLibAppIAMConditionInput
) {
  updateProductLibAppIAM(input: $input, condition: $condition) {
    id
    username
    name
    email
    role
    departmentMain
    departmentSub
    editorBrandTypes
    approverBrandTypes
    skipNotificationBrandTypes
    notifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibAppIAMMutationVariables,
  APITypes.UpdateProductLibAppIAMMutation
>;
export const deleteProductLibAppIAM = /* GraphQL */ `mutation DeleteProductLibAppIAM(
  $input: DeleteProductLibAppIAMInput!
  $condition: ModelProductLibAppIAMConditionInput
) {
  deleteProductLibAppIAM(input: $input, condition: $condition) {
    id
    username
    name
    email
    role
    departmentMain
    departmentSub
    editorBrandTypes
    approverBrandTypes
    skipNotificationBrandTypes
    notifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibAppIAMMutationVariables,
  APITypes.DeleteProductLibAppIAMMutation
>;
export const createProductLibBanner = /* GraphQL */ `mutation CreateProductLibBanner(
  $input: CreateProductLibBannerInput!
  $condition: ModelProductLibBannerConditionInput
) {
  createProductLibBanner(input: $input, condition: $condition) {
    id
    order
    brand
    name
    mimeType
    path
    description
    periodStart
    periodEnd
    status
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibBannerMutationVariables,
  APITypes.CreateProductLibBannerMutation
>;
export const updateProductLibBanner = /* GraphQL */ `mutation UpdateProductLibBanner(
  $input: UpdateProductLibBannerInput!
  $condition: ModelProductLibBannerConditionInput
) {
  updateProductLibBanner(input: $input, condition: $condition) {
    id
    order
    brand
    name
    mimeType
    path
    description
    periodStart
    periodEnd
    status
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibBannerMutationVariables,
  APITypes.UpdateProductLibBannerMutation
>;
export const deleteProductLibBanner = /* GraphQL */ `mutation DeleteProductLibBanner(
  $input: DeleteProductLibBannerInput!
  $condition: ModelProductLibBannerConditionInput
) {
  deleteProductLibBanner(input: $input, condition: $condition) {
    id
    order
    brand
    name
    mimeType
    path
    description
    periodStart
    periodEnd
    status
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibBannerMutationVariables,
  APITypes.DeleteProductLibBannerMutation
>;
export const createProductLibLtpPrice = /* GraphQL */ `mutation CreateProductLibLtpPrice(
  $input: CreateProductLibLtpPriceInput!
  $condition: ModelProductLibLtpPriceConditionInput
) {
  createProductLibLtpPrice(input: $input, condition: $condition) {
    id
    ltpId
    materialCode
    pricePerDozen
    periodStart
    periodEnd
    lastSyncDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductLibLtpPriceMutationVariables,
  APITypes.CreateProductLibLtpPriceMutation
>;
export const updateProductLibLtpPrice = /* GraphQL */ `mutation UpdateProductLibLtpPrice(
  $input: UpdateProductLibLtpPriceInput!
  $condition: ModelProductLibLtpPriceConditionInput
) {
  updateProductLibLtpPrice(input: $input, condition: $condition) {
    id
    ltpId
    materialCode
    pricePerDozen
    periodStart
    periodEnd
    lastSyncDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLibLtpPriceMutationVariables,
  APITypes.UpdateProductLibLtpPriceMutation
>;
export const deleteProductLibLtpPrice = /* GraphQL */ `mutation DeleteProductLibLtpPrice(
  $input: DeleteProductLibLtpPriceInput!
  $condition: ModelProductLibLtpPriceConditionInput
) {
  deleteProductLibLtpPrice(input: $input, condition: $condition) {
    id
    ltpId
    materialCode
    pricePerDozen
    periodStart
    periodEnd
    lastSyncDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductLibLtpPriceMutationVariables,
  APITypes.DeleteProductLibLtpPriceMutation
>;
export const syncProduct = /* GraphQL */ `mutation SyncProduct(
  $startDate: String
  $endDate: String
  $type: String
  $brand: String
) {
  syncProduct(
    startDate: $startDate
    endDate: $endDate
    type: $type
    brand: $brand
  )
}
` as GeneratedMutation<
  APITypes.SyncProductMutationVariables,
  APITypes.SyncProductMutation
>;
export const syncLtpPrice = /* GraphQL */ `mutation SyncLtpPrice($syncDate: String, $materialCode: String) {
  syncLtpPrice(syncDate: $syncDate, materialCode: $materialCode)
}
` as GeneratedMutation<
  APITypes.SyncLtpPriceMutationVariables,
  APITypes.SyncLtpPriceMutation
>;
export const rebuildSearchIndex = /* GraphQL */ `mutation RebuildSearchIndex {
  rebuildSearchIndex {
    version
    buildTimestamp
    count
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RebuildSearchIndexMutationVariables,
  APITypes.RebuildSearchIndexMutation
>;
